import React from 'react'
import Header from 'components/template/Header'
import SidePanel from 'components/template/SidePanel'
import UserDropdown from 'components/template/UserDropdown'
import HeaderLogo from 'components/template/HeaderLogo'
import MobileNav from 'components/template/MobileNav'
import HorizontalNav from 'components/template/HorizontalNav'
import View from 'views'
import SelectPlan from 'views/user/selectPlan'
import AuthSidePanelLogin from 'components/template/AuthSidePanel'
import { AuthSidePanelSignup } from 'components/template/AuthSidePanel/signUp'
import { AuthSidePanelReset } from 'components/template/AuthSidePanel/reset'

const HeaderActionsStart = () => {
    return (
        <>
            <HeaderLogo />
            <MobileNav />
        </>
    )
}

const HeaderActionsEnd = () => {
    return (
        <>
            <AuthSidePanelLogin />
            <AuthSidePanelSignup />
            <AuthSidePanelReset />
            <SidePanel />
            <SelectPlan />

            <HorizontalNav />

            <UserDropdown hoverable={false} />
        </>
    )
}

const SimpleLayout = () => {
    return (
        <div className="app-layout-simple flex flex-auto flex-col">
            <div className="flex flex-auto min-w-0">
                <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
                    <Header
                        className="border-b border-gray-200 dark:border-gray-700"
                        headerStart={<HeaderActionsStart />}
                        // headerMiddle={}
                        headerEnd={<HeaderActionsEnd />}
                    />
                    <View pageContainerType="gutterless" />
                </div>
            </div>
        </div>
    )
}

export default SimpleLayout
